// CỜ VÀNG / ĐỎ TRÊN THẺ BƯỚC (Giai đoạn 0 · pha B, 07/10/2026 — "cảnh báo thay vì cấm cứng khi soạn sơ đồ"). Hàm THUẦN cho trang Kịch bản (chỉ import hàm
// nhẹ — không kéo thư viện khối/YAML/zod): trang tính cờ NGAY trên sơ đồ đang hiện (lạc quan, trước khi máy chủ trả lời) bằng CHÍNH hàm của máy chủ
// (so-do-thu-tu.ts phanLoaiThuTu + so-do-sua.ts thieuThamSoCua) nên chữ "Bước N (…)" khớp với số bước trên màn hình; khi hàng đợi lưu rảnh trang dùng danh
// sách của máy chủ (canhBaoBuoc — có thêm các cờ chỉ máy chủ tính được, vd bỏ bài của chính mình) qua coTuMayChu.
//   VÀNG = nên xem lại, VẪN chạy được.   ĐỎ = thiếu đầu vào, KHÔNG chạy (Chạy thử + Chạy thật bị từ chối kèm danh sách).
import { thieuThamSoCua, type ThamSoThieuDef } from "./so-do-sua";
import { mucThuTuHieuLuc, phanLoaiThuTu, type MucCanhBao, type ThuTuThaoTac, type ThuTuTuTim } from "./so-do-thu-tu";

/** Một cờ của một bước: `loi` = câu đầy đủ ("Bước 2 (Tên) …") giống chữ của máy chủ. */
export interface CoBuoc { muc: MucCanhBao; ma: string; loi: string }
/** Phần định nghĩa thao tác (bản đồ công khai) cần để tính cờ. */
export interface ThaoTacChoCo { ma: string; tenNgan: string; thuTu: ThuTuThaoTac; thuTuTuTim?: ThuTuTuTim; thamSo: readonly (ThamSoThieuDef & { luaChon?: string[] })[] }

/** Cờ theo từng bước (chỉ số = vị trí 0-based trên màn hình). Ô thiếu trước, rồi luật thứ tự — như thứ tự máy chủ. Thao tác lạ / không có bản đồ → không cờ (máy chủ vẫn kiểm). */
export function tinhCoBuoc(nut: readonly { thaoTac: string; thamSo: Record<string, string> }[], thaoTac: readonly ThaoTacChoCo[], hoSoTen?: string | null, mucTieu?: string | null): CoBuoc[][] {
  const co: CoBuoc[][] = nut.map(() => []);
  const tt = nut.map((n) => thaoTac.find((t) => t.ma === n.thaoTac));
  // Như máy chủ chuẩn hoá: ô để trống không có giá trị (lấy mặc định của bản đồ khi tính cấu trúc).
  const chuan = nut.map((n) => ({ thaoTac: n.thaoTac, thamSo: Object.fromEntries(Object.entries(n.thamSo).map(([k, v]) => [k, String(v ?? "").trim()]).filter(([, v]) => v !== "")) as Record<string, string> }));
  nut.forEach((n, j) => {
    const t = tt[j];
    if (!t) return;
    for (const x of thieuThamSoCua(t.thamSo, n.thamSo)) co[j]!.push({ muc: "do", ma: x.ma, loi: `Bước ${j + 1} (${t.tenNgan}): ${x.lyDo}` });
  });
  if (nut.length && !tt.some((t) => !t)) {
    const muc = mucThuTuHieuLuc(chuan, thaoTac, hoSoTen, mucTieu);
    if (muc.length === nut.length) {
      for (const p of phanLoaiThuTu(muc, thaoTac.map((t) => ({ tenNgan: t.tenNgan, taoDs: t.thuTu.taoDs })))) co[p.buoc - 1]?.push({ muc: p.muc, ma: p.ma, loi: p.loi });
    }
  }
  return co;
}

/** Danh sách cờ của máy chủ (chi tiết kịch bản: canhBaoBuoc) → cờ theo từng bước. Số bước ngoài khoảng bị bỏ. */
export function coTuMayChu(canhBaoBuoc: readonly { soThuTu: number; muc: MucCanhBao; ma: string; loi: string }[] | undefined, soNut: number): CoBuoc[][] {
  const co: CoBuoc[][] = Array.from({ length: soNut }, () => []);
  for (const c of canhBaoBuoc ?? []) co[c.soThuTu - 1]?.push({ muc: c.muc, ma: c.ma, loi: c.loi });
  return co;
}

/** Mức của MỘT bước: có cờ đỏ → "do"; chỉ vàng → "vang"; không cờ → null. */
export function mucCuaBuoc(co: readonly CoBuoc[]): MucCanhBao | null {
  return co.some((c) => c.muc === "do") ? "do" : co.length ? "vang" : null;
}

/** Tổng hợp cho hộp trên đầu sơ đồ: số thứ tự (từ 1) các bước ĐỎ và các bước VÀNG (bước vừa đỏ vừa vàng chỉ tính đỏ). */
export function tomTatCo(co: readonly (readonly CoBuoc[])[]): { buocDo: number[]; buocVang: number[] } {
  const buocDo: number[] = [], buocVang: number[] = [];
  co.forEach((c, i) => { const m = mucCuaBuoc(c); if (m === "do") buocDo.push(i + 1); else if (m === "vang") buocVang.push(i + 1); });
  return { buocDo, buocVang };
}

/** Mọi dòng ĐỎ (một bước có thể nhiều dòng) theo thứ tự bước — để liệt kê khi Chạy bị từ chối. */
export function dongDo(co: readonly (readonly CoBuoc[])[]): { soThuTu: number; loi: string }[] {
  return co.flatMap((c, i) => c.filter((x) => x.muc === "do").map((x) => ({ soThuTu: i + 1, loi: x.loi })));
}
